<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.insurerNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="项目名称">
              <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="业绩状态" >
              <a-select v-model="queryParam.progress" @change="handleStatusChange" placeholder = "请选择" allowClear>
                <a-select-option v-for="item in businessStatusDict" :key="item.value" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="5">
            <a-form-item label="期数">
              <a-input placeholder="请输入期数" v-model="queryParam.phase"/>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="5" :sm="6">
              <a-form-item label="保单号" >
                <a-input v-model="queryParam.policy" placeholder="请输入保单号"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="6">
              <a-form-item label="投保人">
<!--                <a-input placeholder="请输入投保人" v-model="queryParam.insure"/>-->
                <j-search-select-tag
                  placeholder="请输入投保人"
                  v-model="queryParam.insure"
                  dict="biz_customer,name,name">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="被保人">
                <a-input placeholder="请输入被保险人" v-model="queryParam.insured"/>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="6">
              <a-form-item label="业务类型">
                <j-dict-select-tag
                  placeholder="请选择业务类型"
                  v-model="queryParam.businessType"
                  :options="allBusinessTypeDictOptions">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="8">
              <a-form-item label="经纪人">
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.createBy"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-form-item label="险种名称">
                <a-input placeholder="请输入险种名称" v-model="queryParam.insuranceName"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="导入日期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.createTimeRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="保险期间">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.insuranceRange"
                  format="YYYY-MM-DD"
                  :placeholder="['保险起期', '保险讫期']"
                  @change="onInsDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="保险起期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.insuranceStartRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onStartDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="保险讫期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.insuranceEndRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onEndDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="车牌号" >
                <a-input v-model="queryParam.car" placeholder="请输入车牌号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="标的类型" >
                <!--<a-input v-model="queryParam.productOrLife" placeholder="请输入车牌号"></a-input>-->
                <j-dict-select-tag
                  placeholder="请选择"
                  v-model="queryParam.productOrLife"
                  dictCode="product_or_life">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8" v-if="shouldShowDeptQuery">
              <a-form-item label="部门" >
                <j-dict-select-tag
                  placeholder="请选择部门"
                  v-model="queryParam.sysOrgCode"
                  dictCode="sys_depart,depart_name,org_code">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="14">
              <a-form-item label="险种类型">
                <j-dict-select-tag
                  placeholder="请选择险种类型"
                  v-model="queryParam.insuranceType"
                  dictCode="bms_insurance_type">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="10">
              <a-form-item label="业绩编号" >
                <a-input v-model="queryParam.businessNumber" placeholder="请输入业绩编号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="保单附件" >
                <a-select v-model="queryParam.hasFile" placeholder = "请选择" allowClear>
<!--                  <a-select-option v-for="item in businessStatusDict" :key="item.file" :value="item.file">
                    {{ item.text }}
                  </a-select-option>-->
                  <a-select-option :key="0" :value="0">未上传</a-select-option>
                  <a-select-option :key="1" :value="1">已上传</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="确认时间">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.confirmRange"
                  format="YYYY-MM-DD"
                  :placeholder="['确认起期', '确认止期']"
                  @change="onConfirmDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="核算日期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.accountDateRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onAccountDateChange"
                />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleBatchAudit" type="primary"   v-has="'businessInfo:add'">提交审核</a-button>-->
      <a-button @click="customHandleAdd('0')" type="primary" icon="plus" v-has="'businessInfo:add'">新增</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel" v-if="'businessInfo:import'">
        <a-button type="primary" icon="importNew" >业绩导入</a-button>
      </a-upload>
      <a-button type="primary" icon="download" @click="handleExport('业绩报送表')" v-has="'businessInfo:export'">导出</a-button>
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importHistoryExcelUrl" @change="handleImportExcel" v-has="'businessInfo:importHistory'">
        <a-button type="primary" icon="importHistory" >历史业绩导入</a-button>
      </a-upload>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0" v-has="'businessInfo:del'">-->
        <!--<a-menu slot="overlay">-->
          <!--<a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>-->
        <!--</a-menu>-->
        <!--<a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
      <!--</a-dropdown>    v-has="'businessInfo:commit'" v-has="'businessInfo:confirm'" -->
      <a-button @click="handleBatchCommit" type="primary" v-has="'businessInfo:batchCommit'">批量提交审核</a-button>
      <a-button @click="handleBatchConfirm('1')" type="primary" v-has="'businessInfo:batchConfirm'">批量确认</a-button>
      <a-button @click="handleBatchConfirm('2')" type="primary" v-has="'businessInfo:batchBack'">批量退回</a-button>
      <a-button type="primary" icon="download" @click="handleDownloadTemplate">模板下载(26-02-11)</a-button>
      <a-modal v-model="templateModalVisible" title="模板下载" @ok="handleTemplateOK">
        <a style="margin-right:30px;" :href="`${path}业绩递交模板_02.11.xls`" download="业绩递交模板.xls">业绩递交模板</a>
      </a-modal>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="margin-left: 60px" >金额单位：元</span>
        <span style="margin-left: 24px" >保费合计：{{premiumTotal}}</span>
        <span style="margin-left: 24px" >去税保费合计：{{cleanPremiumTotal}}</span>
        <span style="margin-left: 24px" >总佣金合计：{{brokerageTotal}}</span>
        <span style="margin-left: 24px" >去税佣金合计：{{cleanBrokerageTotal}}</span>
      </div>

      <!--, y:theight-->
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, onSelect: onSelectedSelect, onSelectAll: onSelectedAll}"
        :rowClassName="setRowClassName"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <span v-else>
            <a-button
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="downloadFile(downUrl+text)">
              下载
            </a-button>
<!--            <a style="margin-left: 15px;" :href="previewFile(text)" target="_blank">预览</a>-->
            <a-button
              :ghost="true"
              type="primary"
              icon="preview"
              size="small"
              @click="preview(downUrl+text)">
              预览
            </a-button>
          </span>
        </template>
        <template slot="statusSlot" slot-scope="text, record">
          <span>{{getStatus(record)}}</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record);">详情</a>
          <a-divider type="vertical"/>
          <a v-if="record.status==3" @click="handleInvoiceInfo(record)">发票</a>
          <a-divider v-if="record.status==3" type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
<!--              <a-menu-item v-if="record.status=='0' || record.status=='2'" v-has="'businessInfo:edit'" >
                <a @click="updateStatus(record, 4)" >提交审核</a>
              </a-menu-item>
              <a-menu-item v-if="record.status== '4'" v-has="'businessInfo:confirm'" >
                <a @click="updateStatus(record, 11)" >确认</a>
              </a-menu-item>
              <a-menu-item v-if="record.status=='4' || record.status=='1'" v-has="'businessInfo:sendBack'" >
                <a @click="updateStatus(record, 2)" >退回</a>
              </a-menu-item>-->

              <a-menu-item v-if="record.status=='0' || record.status=='2'" v-has="'businessInfo:edit'" >
                <a @click="handleEdit(record)" >编辑</a>
              </a-menu-item>
              <a-menu-item v-if="record.status=='0' || record.status=='2'" v-has="'businessInfo:del'" >
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'businessInfo:edit'" ><!--单独编辑图片 v-if="record.status==1 || record.status==3"-->
                <a @click="handleModifyFile(record)" >修改附件</a>
              </a-menu-item>
              <a-menu-item v-has="'businessInfo:edit'" @click="handleCopyAdd(record)" >
                <a>复制新增</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <biz-businessinfo-modal ref="modalForm" @ok="modalFormOk"></biz-businessinfo-modal>
    <a-modal v-model="modalVisible" title="附件" :closable="false" :keyboard="false">
        <j-upload v-model="fileList" :trigger-change="true" bizPath="achievement"
                  @change="handleFileChange" :isFileTypeNeeded="true">
        </j-upload>
      <!-- 自定义 footer 插槽 -->
      <template #footer>
        <a-button key="submit" type="primary" @click="handleModifyFileOk">确定</a-button>
      </template>
    </a-modal>
    <a-modal ref="invoiceModal" v-if="invoiceModalVisible" :visible.sync="invoiceModalVisible" title="发票信息" @ok="handleOk" @cancel="handleCancel">
      <biz-businessinfo-invoice-form :businessinfoId="businessinfoId">
      </biz-businessinfo-invoice-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj, padRightAndFormatter } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BizBusinessinfoModal from './modules/BizBusinessinfoModal'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getAction, postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import { mapGetters } from 'vuex'
  import JUpload from '@/components/jeecg/JUpload'
  import BizBusinessinfoInvoiceForm from './modules/BizBusinessinfoInvoiceForm'
  import {AllBusinessTypeDictOptions} from '../enums/businessTypeDictOptions'
  import {BusinessStatusDict_Manual, BusinessInfoStatus} from "../enums/BusinessDict"
  import ProjectConst from '../project/ProjectConst'

  export default {
    name: 'BizBusinessinfoList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      BizBusinessinfoModal,
      JDate,
      JUpload,
      BizBusinessinfoInvoiceForm
    },
    data () {
      return {
        description: '业绩报送表管理页面',
        disableMixinCreated: true,
        hasImportNewDataPermission: false, //导入历史数据按钮权限，单独判断
        queryFlag:false, //标识是否查询(成功),查询成功显示相关批量操作按钮
        businessStatusDict:[], //业绩状态字典
        allBusinessTypeDictOptions:[],
        invoiceModalVisible:false,
        templateModalVisible: false,
        downUrl:window._CONFIG['downloadUrl'],
        businessinfoId:'', //当前选择的id
        modalVisible: false,
        path: ProjectConst.OSS_ADR_TEMPLATE,
        modifyId: '', // 修改文件的单据id
        fileList: '', //文件列表字符串
        fileType: '', // 存储 fileType

        totalBrokerageTotal: 0.0, // 合计
        totalCleanBrokerageTotal: 0.0,
        totalCleanPremiumTotal: 0.0,
        // totalInvoiceAmountTotal: 0.0,
        totalPremiumTotal: 0.0,
        totalOutInvoiceTotal: 0.0,

        brokerageTotal: 0.0, // 合计
        cleanBrokerageTotal: 0.0,
        cleanPremiumTotal: 0.0,
        // invoiceAmountTotal: 0.0,
        premiumTotal: 0.0,
        outInvoiceTotal: 0.0,
        selectedRows: [],
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'业绩编号',
            className:'column-text',
            dataIndex: 'businessNumber',
            sorter: true
          },
          {
            title:'业绩状态',
            align:"center",
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
          {
            title:'标的类型',
            align:"center",
            dataIndex: 'productOrLife_dictText'
          },
          /*{
            title:'业绩类型',
            align:"center",
            dataIndex: 'businessPerformanceType_dictText'
          },*/
          {
            title:'项目',
            className:"column-text",
            dataIndex: 'project_dictText'
          },
          {
            title:'二级单位',
            className:"column-text",
            dataIndex: 'insureParentOrg_dictText'
          },
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'createBy_dictText',
            sorter: true
          },
          {
            title:'部门',
            className:"column-text",
            dataIndex: 'sysOrgCode_dictText',
            sorter: true
          },
          {
            title:'投保人',
            className:"column-text",
            dataIndex: 'insure'
          },
          {
            title:'被保险人',
            className:"column-text",
            dataIndex: 'insured'
          },
          {
            title:'保险人',
            className:"column-text",
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title:'险种类型',
            className:"column-text",
            dataIndex: 'insuranceType_dictText'
          },
          {
            title:'险种名称',
            className:"column-text",
            dataIndex: 'insuranceName'
          },
          {
            title:'车牌号',
            className:'column-text',
            dataIndex: 'car'
          },
          {
            title:'保险起期',
            className:"column-text",
            dataIndex: 'insuranceStart',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保险讫期',
            className:'column-text',
            dataIndex: 'insuranceEnd',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'核算日期',
            className:'column-text',
            dataIndex: 'accountDate',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保单状态',
            className:'column-text',
            dataIndex: 'policyStatus',
            sorter: true,
            customRender:function (text) {
              return text;
            }
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy',
            sorter: true
          },
          {
            title:'保额',
            className:'column-money',
            dataIndex: 'insuredAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'费率',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '': text + '‰'
            }
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'premium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'去税保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'是否含税',
            align:"center",
            dataIndex: 'includeTax_dictText'
          },
          {
            title:'缴费类型',
            align:"center",
            dataIndex: 'lifeInsurancePayType_dictText'
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return text == null? '': text + '%'
            }
          },
          {
            title:'总佣金',
            className:'column-money',
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'净佣金',
            className:'column-money',
            dataIndex: 'invoiceCleanAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'开票日期',
            className:'column-text',
            dataIndex: 'invoiceDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'发票号码',
            className:'column-text',
            dataIndex: 'invoiceNo',
          },
          {
            title:'到账日期',
            className:'column-text',
            dataIndex: 'payDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'开票金额',
            className:'column-money',
            // 开票金额展示口径即总佣金：invoice_amount 为历史字段，2025年起新数据多为0，不可直接展示
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
/*          {
            title:'票外金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'outsideInvoiceAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },*//*V7*/
          {
            title:'发票税率',
            className:'column-money',
            dataIndex: 'taxRate',
          },
          {
            title:'开票单位', //九安、 九安分公司
            className:'column-text',
            dataIndex: 'invoiceUnit_dictText',
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
          {
            title:'区域',
            className:'column-text',
            dataIndex: 'zone'
          },
          {
            title:'新增/导入日期',
            className:'column-text',
            dataIndex: 'createTime'
          },
          {
            title:'确认时间',
            className:'column-text',
            dataIndex: 'confirmTime'
          },
          {
            title:'协议附件',
            align:"center",
            dataIndex: 'file',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],

        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['5','10', '50', '100','500'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },

        url: {
          list: "/bms/bizBusinessinfo/list",
          delete: "/bms/bizBusinessinfo/delete",
          deleteBatch: "/bms/bizBusinessinfo/deleteBatch",
          exportXlsUrl: "/bms/bizBusinessinfo/exportXls?extraParam=0",
          importExcelUrl: "bms/bizBusinessinfo/importNewExcel", // 当前业绩导入
          importHistoryExcelUrl: "bms/bizBusinessinfo/importHistoryExcel", // 历史业绩导入
          updateStatus: "/bms/bizBusinessinfo/confirmOrBack",
          getMoneyTotal: '/bms/bizBusinessinfo/getMoneyTotal',
          updateFile: '/bms/bizBusinessinfo/updateFile', // 修改附件
          updateFilePathImmediate: "/bms/bizBusinessinfo/updateFilePathImmediate", // 即时处理文件操作
          batchCommit:"/bms/bizBusinessinfo/batchCommit",
          batchConfirm:"/bms/bizBusinessinfo/batchConfirm",
          preView:"/sys/common/pdf/preview/pdfpreview",
        },
        //dictOptions:{},
      }
    },
    created() {
      //this.setHasImportNewDataPermission();
      this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions
      this.businessStatusDict = BusinessStatusDict_Manual
    },
    // beforeMount(){
    //   let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   this.theight = clientHeight - 490;
    //   console.log("theight:" + this.theight)
    // },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}?extraParam=0`;
      },
      importHistoryExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importHistoryExcelUrl}`;
      },
      // 判断是否应该显示部门查询框
      shouldShowDeptQuery() {
        const userInfo = this.$store.getters.userInfo;

        const userDeptCode = userInfo.orgCode;
        const allowedDepts = ['A03', 'A03A01'];

        return allowedDepts.includes(userDeptCode);
      }
    },
    methods: {
      ...mapGetters(["userInfo"]),
      initDictConfig(){
      },
      handleExport(fileName){
        console.log("handleexport")
        // 校验1：必须执行过查询且查询成功
        if(!this.queryFlag){
          this.$message.warning('请先进行查询操作后再导出！')
          return
        }
        // 校验2：检查数据是否为空
        if(this.dataSource.length === 0){
          this.$message.warning('没有可导出的数据！')
          return
        }
        // 校验3：检查总条数是否超过限制（可选）
/*        const MAX_EXPORT_COUNT = 1000
        if(this.ipagination.total > MAX_EXPORT_COUNT){
          this.$message.warning(`导出数据量过大（最多支持${MAX_EXPORT_COUNT}条）`)
          return
        }*/
        // 所有校验通过后执行导出
        this.handleExportXls(fileName)
      },

      handleInvoiceInfo(record){
        this.businessinfoId = record.id
        this.invoiceModalVisible = true
      },
      getStatus(record){
        // 业绩状态 0未提交 1已确认 2已退回 3已匹配
        if(record.status == BusinessInfoStatus.UNCONFIRM){
          return "未提交"
        } else if(record.status == BusinessInfoStatus.RETURNED){
          return "已退回"
        } else if(record.status == BusinessInfoStatus.SUBMIT){
          return "已提交"
        } else if(record.status == BusinessInfoStatus.CONFIRMED){
          return "已确认"
        }  else if(record.status == BusinessInfoStatus.MATCHED){
          return "已匹配"
        }
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
        //清空汇总
        this.selectedRows = [];
        this.sumTotal();
      },
      onSelectedSelect(record, selected, selectedRows, nativeEvent){
        //单选
        this.calculateTotalAmount(selected,new Array(record));
      },
      onSelectedAll(selected, selectedRows, changeRows){
        //批量选
        this.calculateTotalAmount(selected,selectedRows);
      },
      calculateTotalAmount(checked, rows){
        //计算汇总金额
        if(rows && rows.length > 0){
          rows.forEach(row => {
            if(checked){
              //增加选中行
              this.selectedRows.push(row);
            }else{
              //删除选中行
              var index = this.selectedRows.indexOf(row);
              if(index>=0){
                this.selectedRows.splice(index);
              }
            }
          })
        }
        //排重
        this.selectedRows = [...new Set(this.selectedRows)];
        this.sumTotal();
      },
      sumTotal(){
        //重新统计汇总金额
        if(this.selectedRows && this.selectedRows.length>0){
          this.brokerageTotal = 0.0;
          this.cleanBrokerageTotal = 0.0;
          // this.invoiceAmountTotal = 0.0;
          this.premiumTotal = 0.0;
          this.cleanPremiumTotal = 0.0;
          this.outInvoiceTotal = 0.0;
          for(var i =0 ; i< this.selectedRows.length ; i ++){
            var row = this.selectedRows[i];
            console.log(row);
            this.brokerageTotal += row.brokerageTotal;
            // this.invoiceAmountTotal += row.invoiceAmount;
            this.premiumTotal += row.premium;
            this.cleanPremiumTotal += row.cleanPremium;
            this.cleanBrokerageTotal += (row.invoiceCleanAmount);
          }
          this.premiumTotal = padRightAndFormatter((parseFloat(this.premiumTotal.toString()
            .replace(",",""))).toFixed(2))
          this.brokerageTotal = padRightAndFormatter((parseFloat(this.brokerageTotal.toString()
            .replace(",",""))).toFixed(2))
          // this.invoiceAmountTotal = padRightAndFormatter((parseFloat(this.invoiceAmountTotal.toString()
          //   .replace(",",""))).toFixed(2))
          this.cleanPremiumTotal  = padRightAndFormatter((parseFloat(this.cleanPremiumTotal.toString()
            .replace(",",""))).toFixed(2))
          this.cleanBrokerageTotal  = padRightAndFormatter((parseFloat(this.cleanBrokerageTotal.toString()
          .replace(",",""))).toFixed(2))
        }else{
          this.brokerageTotal = this.totalBrokerageTotal;
          this.cleanBrokerageTotal = this.totalCleanBrokerageTotal;
          // this.invoiceAmountTotal = this.totalInvoiceAmountTotal;
          this.premiumTotal = this.totalPremiumTotal;
          this.cleanPremiumTotal = this.totalCleanPremiumTotal;
        }
      },
      // 复制当前数据并新增一条
      handleCopyAdd(record){
        this.$refs.modalForm.copyAdd(record);
        this.$refs.modalForm.title = "复制新增";
        this.$refs.modalForm.disableSubmit = false;
      },

      // 导入日期选择
      onStartDateChange: function (value, dateString) {
        this.queryParam.insuranceStartRange = dateString;
      },
      // 导入日期选择
      onEndDateChange: function (value, dateString) {
        this.queryParam.insuranceEndRange = dateString;
      },
      // 核算日期选择
      onAccountDateChange: function (value, dateString) {
        this.queryParam.accountDateRange = dateString;
      },

      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        
        // 添加 extraParam 参数
        const urlExtraParam = this.getExtraParamFromUrl();
        if (urlExtraParam !== null) {
          param.extraParam = urlExtraParam;
        }
        //%在后端做了处理，如果添加了新的模糊匹配，请修改后端计算合计的方法。
        if(param.policy){
          param.policy = `*${param.policy}*` // 保单号模糊匹配
        }
        if(param.insuranceName){
          param.insuranceName = `*${param.insuranceName}*` // 险种名称模糊匹配
        }
        if(param.car){
          param.car = `*${param.car}*` // 车牌号模糊查询
        }
        if(param.businessNumber){
          param.businessNumber = `*${param.businessNumber}*` // 业绩编号模糊查询
        }
        // 导入日期
/*        if(param.createTimeRange){
          param.createTime_begin = param.createTimeRange[0] + ' 00:00:00'
          param.createTime_end = param.createTimeRange[1] + ' 23:59:59'
          delete param.createTimeRange
        }*/
        if (Array.isArray(param.createTimeRange) && param.createTimeRange.length === 2) {
          const [start, end] = param.createTimeRange;

/*          param.createTime_begin = start + ' 00:00:00';
          param.createTime_end = end + ' 23:59:59';

          delete param.createTimeRange;*/

          // 增加类型检查
          if (typeof start === 'string' && typeof end === 'string' && start && end) {
            param.createTime_begin = `${start} 00:00:00`;
            param.createTime_end = `${end} 23:59:59`;
            delete param.createTimeRange;
          } else {
            // 可以添加错误处理或默认行为
            console.warn('Invalid createTimeRange values');
          }
        }

        // 保险期间
        if(param.insuranceRange && param.insuranceRange[0]){
          param.ins_begin = param.insuranceRange[0] + ' 00:00:00'
          param.ins_end = param.insuranceRange[1] + ' 23:59:59'
        }
        delete param.insuranceRange
        // 确认期间
        if(param.confirmRange && param.confirmRange[0]){
          param.confirm_begin = param.confirmRange[0] + ' 00:00:00'
          param.confirm_end = param.confirmRange[1] + ' 23:59:59'
        }
        delete param.confirmRange

        // 核算日期
        if(param.accountDateRange && param.accountDateRange[0]){
          param.account_date_begin = param.accountDateRange[0]
          param.account_date_end = param.accountDateRange[1]
        }
        delete param.accountDateRange

        //保险起期
        if(param.insuranceStartRange && param.insuranceStartRange[0]){
          param.insuranceStart_begin = param.insuranceStartRange[0]
          param.insuranceStart_end = param.insuranceStartRange[1]
        }
        delete param.insuranceStartRange
        //保险讫期
        if(param.insuranceEndRange && param.insuranceEndRange[0]){
          param.insuranceEnd_begin = param.insuranceEndRange[0]
          param.insuranceEnd_end = param.insuranceEndRange[1]
        }
        delete param.insuranceEndRange

        // 进度处理
        if(param.progress){
          param.status = param.progress
          delete param.progress
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },
      handleBatchAudit(event){
        this.inputContent = event.target.value
        this.$emit('change',this.inputContent)
      },
      loadData(arg) {
        if (arg == 1) {
          this.ipagination.current = 1
          this.onClearSelected();
        }
        let params = this.getQueryParams();
        this.loading = true
        let url = `${this.url.list}`
        getAction(url, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.queryFlag = true //查询成功设置按钮可见

            if(this.ipagination.current === 1){[']10']
              //删除排序条件
              delete params.column
              delete params.order
              getAction(this.url.getMoneyTotal, params).then((result)=>{
                if (result.success) {
                  this.brokerageTotal = !result.result.brokerageTotal ? '': result.result.brokerageTotal.toLocaleString()
                  this.cleanPremiumTotal = !result.result.cleanPremiumTotal ? '': result.result.cleanPremiumTotal.toLocaleString()
                  // this.invoiceAmountTotal = !result.result.invoiceAmountTotal ? '': result.result.invoiceAmountTotal.toLocaleString()
                  this.premiumTotal = !result.result.premiumTotal ? '': result.result.premiumTotal.toLocaleString()
                  this.cleanBrokerageTotal = !result.result.cleanBrokerageTotal ? '': result.result.cleanBrokerageTotal.toLocaleString()
                  if(this.outInvoiceTotal===""){this.outInvoiceTotal=0.00}
                  //更新汇总金额缓存
                  this.totalBrokerageTotal = this.brokerageTotal;
                  this.totalCleanBrokerageTotal = this.cleanBrokerageTotal;
                  this.totalCleanPremiumTotal = this.cleanPremiumTotal;
                  // this.totalInvoiceAmountTotal = this.invoiceAmountTotal;
                  this.totalPremiumTotal = this.premiumTotal;
                  this.sumTotal();
                }
              })
            }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      //单条更新状态,提交审核、确认或退回
      updateStatus(record, status){
        if(record === undefined || record === null){
          return
        }
        let param = {id: record.id, status: status}
        postAction(this.url.updateStatus, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.result)
          }
        })
      },
      handleInvoiceTimeChange(event){
        if(event){
          this.queryParam.progress = undefined; // 清空进度
        }
      },
      // 是否有导入业绩权限 盛泰巴和分支机构有, 管理员有
      setHasImportNewDataPermission(){
        let currentDepart = this.userInfo().orgCode;
        let username = this.userInfo().username;
        if(username === 'admin' || currentDepart==='A03A10' || currentDepart.indexOf('A03A08A')>=0){
          this.hasImportNewDataPermission = true;
        }
      },

      // 修改附件
      handleModifyFile(record){
        if(record.fileUpdateCount >= 2){
          this.$message.warning("附件已修改两次，不能再修改")
          return
        }
        this.modifyId = record.id
        this.fileList = record.file
        this.modalVisible = true
      },

      //确认按钮, 保存当前列表
      handleModifyFileOk(event){
        // 确保 fileList 存在
        let path = '';
        if (this.fileList && this.fileList.path) {
          path = this.fileList.path;
        };
        let param = {id: this.modifyId, file: path}
        postAction(this.url.updateFile, param).then(res =>{
          if(res.success){
            this.modalVisible = false
            this.$message.info("修改成功")
            this.loadData()
          } else {
            this.$message.warning("修改失败")
          }
        })
      },

      handleCancel(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },

      handleOk(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },
      
      // 从URL中提取extraParam参数
      getExtraParamFromUrl() {
        const exportUrl = this.url.exportXlsUrl;
        const match = exportUrl.match(/[?&]extraParam=([^&]*)/);
        return match ? match[1] : null;
      },

      // 文件列表改变后及时更新数据库（编辑状态下）
      handleFileChange({ path,fileTypes }){
        // alert("form.fileTypes:"+JSON.stringify(fileTypes));
        const forbiddenTypes = [
          "application/x-zip-compressed",
          "application/x-rar-compressed",
          "application/x-7z-compressed",
          "application/x-tar",
          "application/gzip",
          "application/x-bzip2",
          "application/x-xz",
          "application/x-iso9660-image",
          "application/x-apple-diskimage"
        ];
        // 遍历 fileTypes，判断是否有禁止类型
        const hasForbiddenType = fileTypes.some(type => forbiddenTypes.includes(type));
        if (hasForbiddenType) {
          this.$message.error('不允许上传压缩文件！');
          this.modalVisible = false; // 关闭模态框，阻止 @ok 事件执行
          this.loadData()
          return false; // 阻止文件上传
        }else {
          // 编辑状态下变化，存在单据id
          let id = this.modifyId
          if(id){
            postAction(this.url.updateFilePathImmediate, {id: id, filePath: path}).then(res =>{
              if(res.success){
              } else {
                this.$message.warn("附件更新时出现错误:" + res.message)
              }
            })
          }
        }
      },

      handleBeforeUpload(file, fileList){
        this.loading = true
        return true
      },

      // 导入日期选择
      onDateChange: function (value, dateString) {
        this.queryParam.createTimeRange = dateString;
      },

      // 保险期间选择
      onInsDateChange: function (value, dateString) {
        this.queryParam.insuranceRange = dateString;
      },

      // 确认时间选择
      onConfirmDateChange: function (value, dateString) {
        this.queryParam.confirmRange = dateString;
      },


/*      //返回pdf预览功能的url地址，并放入文件地址
      previewFile(filePath){
        let url = window._CONFIG['domianURL'] + '/sys/common/pdf/preview/'+ encodeURIComponent(filePath)
        return url
      },*/



      handlePreviewPdfOk(event){
        this.$nextTick(()=> {
          this.modalVisible2 = false
        })
      },

      // 预览
      preview(filePath){
        var lowcasepath = filePath.toLowerCase();
        if(lowcasepath.endsWith(".pdf")){
          let param = encodeURIComponent(filePath)
          var url = window._CONFIG['domianURL'] + '/sys/common/pdf/preview?file='+param
          window.open(url,'_blank')
        }else if (lowcasepath.endsWith(".jpg")
          || lowcasepath.endsWith(".png")
          || lowcasepath.endsWith(".bmp")){
          window.open('', '_blank').document.write('<img src = "' +filePath+ '" />');
        }else{
          this.$message.warning("文件类型不支持预览，请下载后查看");
        }
      },

      // 批量提交
      handleBatchCommit(){
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return;
        } else {
          let param = {ids: this.selectedRowKeys}
          postAction(this.url.batchCommit, param).then((res) =>{
            if(res.success){
              this.$message.info(res.message)
              this.loadData(1)
            } else {
              this.$message.warn(res.message)
            }
          })
        }
      },
      // 批量确认、退回
      handleBatchConfirm(status){
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return;
        } else {
          let param = {ids: this.selectedRowKeys, status: status}
          postAction(this.url.batchConfirm, param).then((res) =>{
            if(res.success){
              this.$message.info(res.message)
              this.loadData(1)
            } else {
              this.$message.warn(res.message)
            }
          })
        }
      },

      //模板下载
      handleDownloadTemplate(){
        this.templateModalVisible = true
      },
      handleTemplateOK(){
        this.templateModalVisible = false
      },

      // 改变状态后设置为false，隐藏按钮; 改变值后点击查询按钮，查询成功才能设置为true
      handleStatusChange(){
        this.queryFlag = false
      },
      // 动态设置行类名
      setRowClassName(record) {
        console.log("record:",record.id)
        console.log("this.selectedRows:",this.selectedRows)

        return this.selectedRows.includes(record.id) ? 'selected-row' : '';
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
  /* 选中行的样式 */
  .selected-row {
    background-color: #e6f7ff !important; /* 浅蓝色背景 */
    color: #1890ff !important; /* 蓝色文字（可选） */
  }
</style>
